export default __webpack_public_path__ + "static/media/electricity_gen.2e887b81.svg";